/* eslint-disable */
import httpClient from "@/services/httpClient";

export default {
  getSpotlightInfo: payload => new Promise(((resolve) => {
    setTimeout(() => {
      resolve({ data: require('../../mock/spolightResponse.json') });
    }, 1000)
  })),
  fetchSpotlightCategories: ({ options }) => httpClient.get('/api/v2/mocks/spotlight/categories', options),
  fetchSpotlightHeroes: ({ options }) => httpClient.get('/api/v2/mocks/spotlight/heroes', options),
};
